import { sidebarMenuItems, privatePages } from "../../layout/menu";
import { extractModulesAndSubmodules, filterMenuItems } from "../../commonUtils/permission.helper";
import * as actionTypes from "./actionTypes";

const initialState = {
  loading: false,
  token: "",
  user: null,
  permissions: [],
  permissionModules: [],
  filteredMenuItems: [],
  filteredPrivatePages: [],
  activeMenu: [""],
  errors: {},
  errorMessage: "",
  showLogoutAlert: false,
  refreshTokenStatus: null,
  notFound: false
};

const Auth = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_LOADING:
      return {
        ...state,
        notFound: false,
        loading: action.payload,
      };
    case actionTypes.UPDATE_USER_STATE: {
      const { permModules, permSubmodules } = extractModulesAndSubmodules(action.payload.permissions);
      return {
        ...state,
        notFound: false,
        user: action.payload,
        permissions: action.payload.permissions,
        permissionModules: permModules,
        filteredMenuItems: filterMenuItems(permModules, permSubmodules, sidebarMenuItems, action.payload.permissions),
        filteredPrivatePages: filterMenuItems(permModules, permSubmodules, privatePages, action.payload.permissions),
      };
    }
    case actionTypes.SET_ACTIVE_MENU:
      return {
        ...state,
        activeMenu: action.payload,
      };
    case actionTypes.SET_SHOW_LOGOUT_ALERT:
      return {
        ...state,
        showLogoutAlert: action.payload,
      };
    case actionTypes.SET_MICROSOFT_USERS: {
      return {
        ...state,
        microsoftUsers: action.payload || []
      }
    }
    case actionTypes.LOGIN_SUCCESS: {
      const { permModules, permSubmodules } = extractModulesAndSubmodules(action.payload.user.permissions);
      console.log('[DEBUG] Permissions after login:', action.payload.user.permissions);
      return {
        ...state,
        notFound: false,
        loading: false,
        access_token: action.payload.access_token,
        user: action.payload.user,
        permissions: action.payload.user.permissions,
        permissionModules: permModules,
        filteredMenuItems: filterMenuItems(permModules, permSubmodules, sidebarMenuItems, action.payload.user.permissions),
        filteredPrivatePages: filterMenuItems(permModules, permSubmodules, privatePages, action.payload.user.permissions),
        errors: {},
        errorMessage: "",
      };
    }
    case actionTypes.LOGIN_FAILURE:
      return {
        ...state,
        notFound: false,
        loading: false,
        errors: action.payload.data,
        errorMessage: action.payload.message,
      };
    case actionTypes.LOGOUT_SUCCESS:
      return {
        ...state,
        notFound: false,
        loading: false,
        token: "",
        user: null,
      };
    case actionTypes.LOGOUT_FAILURE:
      return {
        ...state,
        notFound: false,
        loading: false,
        token: "",
        user: null,
        errorMessage: action.message,
      };
    case actionTypes.REFRESH_TOKEN_SUCCESS:
      return {
        ...state,
        notFound: false,
        loading: false,
        token: action.payload.token,
        refreshTokenStatus: 'success',
      };
    case actionTypes.REFRESH_TOKEN_FAILURE:
      return {
        ...state,
        notFound: false,
        loading: false,
        token: "",
        user: null,
        errorMessage: action.message,
        refreshTokenStatus: 'failure',
      };

    case actionTypes.SET_SHOW_NOT_FOUND_PAGE: {
      return {
        ...state,
        notFound: action.payload,
      };
    }
    case actionTypes.FETCH_MICROSOFT_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        microsoftUsers: action.payload,
        errorMessage: "",
      };
    case actionTypes.FETCH_MICROSOFT_USERS_FAILURE:
      return {
        ...state,
        loading: false,
        microsoftUsers: [],
        errorMessage: action.message,
      };
    default:
      return state;
  }
};

export default Auth;
